import { ContentBlock, FlexGap, FlexJustify, Padding, useLayout, useTranslation } from '@ukpostbox/frontend-framework';
import React from 'react';
import { faLocationCrosshairs } from '@fortawesome/pro-solid-svg-icons/faLocationCrosshairs';
import { useMailbox } from '../../../../Mailboxes/Providers/NewMailboxProvider';

function MailItemIncomingTrackingIdMeta() {
	const { t } = useTranslation();
	const { isTiny, isSmall, isMedium } = useLayout();

	const { mailItemData } = useMailbox();

	if (
		mailItemData?.incomingTrackingId === '' ||
		mailItemData?.incomingTrackingId === null ||
		mailItemData?.incomingTrackingId === undefined
	) {
		return null;
	}

	return (
		<ContentBlock
			title={t('mailItem.labels.trackingIdIn')}
			content={mailItemData?.incomingTrackingId}
			iconContent={{ icon: faLocationCrosshairs, iconSpacing: FlexGap.Small, iconSize: 'lg' }}
			padding={Padding.ExtraSmall}
			stacked={isTiny || isSmall || isMedium}
			justify={FlexJustify.Start}
		/>
	);
}

export { MailItemIncomingTrackingIdMeta };
